<form [formGroup]="form">
    <div class="editor">
        <ngx-editor-menu  [editor]="editor" [toolbar]="toolbar"  [customMenuRef]="customMenu"> </ngx-editor-menu>
        <ngx-editor  [formControlName]="controlName" [editor]="editor"  [ngModel]="html" [disabled]="false" [placeholder]="''">
        </ngx-editor>
    </div>
</form>

<!-- Create template reference -->
<ng-template #customMenu>
    <app-upload *ngIf="showUpload" [editor]="editor"></app-upload>
    <app-shortcode *ngIf="showShortCode" [editor]="editor"></app-shortcode>
    <app-emoji *ngIf="showEmoji" [editor]="editor"></app-emoji>
</ng-template>

